import { GeoCoordinates } from './../location';
export interface DotFitter {
  id: string;
  location: GeoCoordinates;
  distance: number;
  brandId: string;
  brand: string;
  phone: string;
  city?: string;
  internalPhone?: string;
  displayAppointments?: boolean;
  cacheAppointments?: boolean;
  noSlot?: boolean;
}
